import moment from 'moment';

const TIMEZONE_MARKER_REGEX = /(Z|[+-]\d{2}:?\d{2})$/i;
const APPROVAL_INPUT_FORMATS = [
	moment.ISO_8601,
	'DD/MM/YYYY HH:mm:ss',
	'DD/MM/YYYY HH:mm',
	'MM/DD/YYYY HH:mm:ss',
	'MM/DD/YYYY HH:mm',
	'YYYY-MM-DD HH:mm:ss',
	'YYYY-MM-DD HH:mm',
];

const parseApprovalDateTime = (value) => {
	if (!value) return null;

	if (typeof value === 'string' && TIMEZONE_MARKER_REGEX.test(value.trim())) {
		const zonedValue = moment.parseZone(value);
		return zonedValue.isValid() ? zonedValue.local() : null;
	}

	const parsedValue = moment(value, APPROVAL_INPUT_FORMATS, true);
	if (parsedValue.isValid()) {
		return parsedValue;
	}

	const fallbackValue = moment(value);
	return fallbackValue.isValid() ? fallbackValue : null;
};

export const formatApprovalDate = (value, format = 'DD-MM-YYYY') => {
	const parsedValue = parseApprovalDateTime(value);
	return parsedValue ? parsedValue.format(format) : '';
};

export const formatApprovalTime = (value, format = 'hh:mm a') => {
	const parsedValue = parseApprovalDateTime(value);
	return parsedValue ? parsedValue.format(format) : '';
};
